/* Native Dawn inputs and server section responses own variant ID/price/cart. No cart, purchase or order API calls. */
(() => {
  if (customElements.get('s88-thailand-trip')) return;
  const families = {
    'CZ-DTAC349': { from: 3, to: 10, days: 10, type: '一般型', note: '全期共 50GB 高速流量，用完後 384Kbps；不每日重置。' },
    'CZ-DTAC449': { from: 3, to: 8, days: 8, type: '全速型', note: '5G 全速不限量；實際速度依涵蓋範圍、手機及網路負載。' },
    'CZ-DTAC699': { from: 9, to: 15, days: 15, type: '全速型', note: '5G 全速不限量；實際速度依涵蓋範圍、手機及網路負載。' },
    'CZ-TRUE1199': { from: 9, to: 15, days: 30, type: '全速型', note: '5G 全速不限量；實際速度依涵蓋範圍、手機及網路負載。' },
  };
  customElements.define('s88-thailand-trip', class extends HTMLElement {
    connectedCallback() { queueMicrotask(() => this.initialize()); }
    disconnectedCallback() { this.abort?.abort(); clearTimeout(this.pendingTimer); }
    initialize() {
      if (!this.isConnected || this.abort) return;
      try {
        const variants = JSON.parse(this.querySelector('[data-trip-variants]').textContent);
        const inputs = [...this.querySelectorAll('fieldset input[type="radio"]')];
        if (variants.length !== 21 || inputs.length !== 21) return;
        this.rows = inputs.map(input => {
          const matches = variants.filter(v => v.option1 === input.value);
          if (matches.length !== 1) throw Error('variant mapping');
          const variant = matches[0], family = families[variant.sku];
          const match = /^(\d+)天行程｜(一般型|全速型)$/.exec(input.value);
          const day = Number(match?.[1]);
          if (!family || !match || match[2] !== family.type || day < family.from || day > family.to || !Number.isSafeInteger(variant.price) || variant.price <= 0) throw Error('plan contract');
          const label = [...this.querySelectorAll('label')].find(l => l.htmlFor === input.id);
          if (!label || !input.dataset.optionValueId) throw Error('native control');
          return { input, label, variant, family, day };
        });
        if (new Set(this.rows.map(r => r.input.value)).size !== 21 || this.rows.filter(r => r.input.checked).length !== 1) return;
        this.daySelect = this.querySelector('[data-trip-days]');
        this.note = this.querySelector('[data-trip-note]');
        this.abort = new AbortController();
        this.addEventListener('change', event => {
          if (event.target === this.daySelect) {
            // Do not leak this convenience selector into Dawn's native option-value event.
            event.stopPropagation();
            const rows = this.rows.filter(r => r.day === Number(this.daySelect.value)).sort((a, b) => a.variant.price - b.variant.price);
            const next = rows[0]; // Never auto-upgrade to a paid tier when the cheaper plan is sold out.
            if (!next) return;
            next.input.checked = true;
            this.update(next);
            this.pending();
            next.input.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            const next = this.rows.find(r => r.input === event.target);
            if (next) { this.update(next); this.pending(); }
          }
        }, { signal: this.abort.signal });
        for (const row of this.rows) {
          const money = document.createElement('span');
          money.className = 's88-th-plan-price';
          money.textContent = `NT$${(row.variant.price / 100).toLocaleString('zh-TW')}`;
          row.label.append(money);
        }
        this.update(this.rows.find(r => r.input.checked));
        this.querySelector('[data-trip-control]').hidden = false;
        const info = this.closest('product-info');
        const selected = this.rows.find(r => r.input.checked);
        if (info?.querySelector('product-form input[name="id"]')?.value === String(selected.variant.id)) {
          info.querySelectorAll('[data-s88-trip-lock]').forEach(el => { el.inert = false; el.removeAttribute('data-s88-trip-lock'); });
          info.removeAttribute('aria-busy');
        }
      } catch {
        // Fail open to truthful native choices, never fabricate a sellable variant or price.
        for (const row of this.rows || []) { row.input.hidden = false; row.label.hidden = false; }
      }
    }
    pending() {
      const info = this.closest('product-info');
      info?.setAttribute('aria-busy', 'true');
      info?.querySelectorAll('product-form, .shopify-payment-button').forEach(el => {
        if (!el.inert) { el.inert = true; el.setAttribute('data-s88-trip-lock', ''); }
      });
      clearTimeout(this.pendingTimer);
      this.pendingTimer = setTimeout(() => {
        if (info?.hasAttribute('aria-busy')) this.note.textContent += ' 方案更新尚未完成，暫停購買以避免選錯。請重新選擇方案，或重新載入頁面後再試。';
      }, 10000);
    }
    update(row) {
      this.daySelect.value = String(row.day); // No selected attributes: Dawn collects only actual option IDs.
      for (const r of this.rows) { r.input.hidden = r.day !== row.day; r.label.hidden = r.day !== row.day; }
      this.note.textContent = `附註：${row.day} 天行程／${row.family.type}，提供固定 ${row.family.days} 天方案。${row.family.note}同組行程選項的實際方案規格相同，售價依選項顯示。`;
    }
  });
})();
